export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11566.1b11ad84.jpg";